// @flow

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

import MemberDrawer from '../MemberDrawer';
import BotSettingsHeader from './BotSettingsHeader';
import BotSettingsContent from './BotSettingsContent';

import botSettingsHomeStyles from './Styles/BotSettingsHome.Style';

// If you have redux hooks or need them, you can import here:
// import { useDispatch, useSelector } from 'react-redux';

const BotSettingsHome = () => {
  const theme = useTheme();

  // drawer state & controls
  const [mobileOpen, setMobileOpen] = useState(false);

  const usehandleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // If you have any data from Redux, you might do:
  // const dispatch = useDispatch();
  // const user = useSelector((state) => state.user.user);

  return (
    <Box sx={botSettingsHomeStyles.root(theme)}>
      <Helmet>
        <title>Neo | Bot</title>
      </Helmet>

      <BotSettingsHeader
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />

      <MemberDrawer
        mobileOpen={mobileOpen}
        usehandleDrawerToggle={usehandleDrawerToggle}
      />

      <BotSettingsContent />
    </Box>
  );
};

export default BotSettingsHome;